import { render, staticRenderFns } from "./PropertyBlock.vue?vue&type=template&id=20119feb&scoped=true&"
import script from "./PropertyBlock.vue?vue&type=script&lang=js&"
export * from "./PropertyBlock.vue?vue&type=script&lang=js&"
import style0 from "./PropertyBlock.vue?vue&type=style&index=0&id=20119feb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20119feb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSimpleTable,VTextField,VTooltip})
